<!--
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-10-10 17:18:44
 * @Reference:
-->
<template>
  <div class="logo">
    <router-link :to="{path:'/'}">
      <img src="@/assets/images/logo.png" alt="logo" />
      <h1 v-if="showTitle">{{ projectName }}</h1>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
